module.exports = __webpack_public_path__ + "static/media/BrikCoin.6d58b6b5.svg";